import { ResponsivePie } from '@nivo/pie';

import { isMobile } from './constants';

const colors = [
  '#e8c1a0',
  'hsl(19, 70%, 50%)',
  'hsla(205, 100%, 50%, 0.79)',
  '#e8a838',
  '#f1e15b',
  'hsl(14, 70%, 50%)',
  'hsl(195, 100%, 50%)',
  'hsl(31, 70%, 50%)',
  'hsl(214, 70%, 50%)',
  'hsl(356, 70%, 50%)',
  'hsl(531, 70%, 50%)',
  'hsl(53, 70%, 50%)',
  '#1CC705',
  'hsl(183, 70%, 50%)',
  'hsl(162, 70%, 50%)',
  'hsl(89, 70%, 50%)',
  'hsl(310, 70%, 50%)',
  'hsl(348, 70%, 50%)'
];
export const CustomPie = ({ data, CustomLayerComponent, pieProps }) => {
  const commonProperties = {
    height: 400,
    margin: {
      top: 40,
      right: 80,
      bottom: 80,
      left: 80
    },
    data: data,
    animate: true,
    activeOuterRadiusOffset: 8,
    enableArcLabels: true,
    enableArcLinkLabels: isMobile ? false : true,
    arcLinkLabelsSkipAngle: 8,
    arcLinkLabelsStraightLength: 22,
    arcLinkLabelsDiagonalLength: 18,
    fit: true,
    ...pieProps
  };
  return (
    <ResponsivePie
      {...commonProperties}
      innerRadius={0.6}
      padAngle={0.5}
      cornerRadius={5}
      arcLinkLabelsColor={{
        from: 'color'
      }}
      arcLinkLabelsThickness={3}
      arcLinkLabelsTextColor={{
        from: 'color',
        modifiers: [['darker', 1.2]]
      }}
      colors={colors}
      arcLabel={function (e) {
        return `${e.data.allocation_per}%`;
      }}
      arcLabelsSkipAngle={15}
      arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
      layers={['arcs', 'arcLabels', 'arcLinkLabels', 'legends', CustomLayerComponent]}
      legends={
        isMobile && [
          {
            anchor: 'bottom-left',
            direction: 'column',
            justify: false,
            translateX: -80,
            translateY: 56,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: '#999',
            itemDirection: 'left-to-right',
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: 'circle',
            effects: [
              {
                on: 'hover',
                style: {
                  itemTextColor: '#000'
                }
              }
            ]
          }
        ]
      }
    />
  );
};
